import { categoryProps } from '@utils/initial'
import { Request } from '@group-devs/yfp7-global-modules'
import Error from '../404'
import { useRouter } from 'next/router'
import { useState, useRef, useEffect } from 'react'

import InfiniteScroll from 'react-infinite-scroll-component';
import { Row, Col, ProgressBar, Button, DropdownButton, Dropdown } from 'react-bootstrap'
import { FaCheck, FaSortAmountDown, FaChevronDown, FaBars } from 'react-icons/fa'
import Link from 'next/link'
import { HeroWrapper } from '@group-devs/yfp7-global-modules/components/Block'
import herostyles from '@group-devs/yfp7-global-modules/components/hero.module.css'
import { WellnessLayout } from '@components/Block';

import params from '@data/params'
import categoryData from '@data/wellnessCategories'
import sectionData from '@data/sections'

import Image from 'next/image'

const request = new Request(process.env.apiDomain)
 
export async function getServerSideProps({req, res, query}) {
    return {
        props: await categoryProps(req, res, query)
    }
}

function CategoryWrapper(props) {
    if (typeof props.err !== "undefined")
        return <Error statusCode={props.err.code} />

    // Log the props to see what's coming in
    console.log("Category props:", {
        category: props.category,
        auth: props.auth,
        slug: props.query?.slug
    });

    const router = useRouter()
    const slug = router.query.slug
    const sections = sectionData.filter((e) => e.id != 12) || []
    const category = props.category || {}

    console.log("Filtering categoryData:", { 
        slug, 
        categoryDataExists: !!categoryData,
        categoryDataLength: categoryData?.length || 0
    });

    const cat = Array.isArray(categoryData) 
        ? categoryData.filter((e) => e.slug === slug) 
        : [];
    
    // Log cat array to debug
    console.log("Cat array:", cat);
    
    const hasCat = cat && cat.length > 0

    const userId = props.auth?.site_owner ? props.auth.userId : null
    const contactId = props.auth?.site_user ? props.auth.contactId : null
    const accountId = props.site.accountId;

    const { data: info } = request.account.swrAccountProfileData(accountId, "account_user_trial_info");
    const config = info && info.data ? JSON.parse(info.data) : ''
    const tag = config ? config.company_name : 'Shaklee';

    const limit = 8;
    const [search, setSearch] = useState("")
    const [offset, setOffset] = useState(0)
    const [filter, setFilter] = useState('')
    const [sort, setSort] = useState("DATE_DESC")
    const [articles, setArticles] = useState([])
    const [more, hasMore] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [fetchInitiated, setFetchInitiated] = useState(false)
    const [fetchError, setFetchError] = useState(null)
    const prevSlugRef = useRef(slug);
    
    // Function to safely access localStorage (browser-only)
    const getLocalStorageItem = (key, defaultValue = '') => {
        if (typeof window === 'undefined') return defaultValue;
        try {
            const item = localStorage.getItem(key);
            return item !== null ? item : defaultValue;
        } catch (e) {
            console.error("localStorage error:", e);
            return defaultValue;
        }
    };
    
    // Function to safely set localStorage (browser-only)
    const setLocalStorageItem = (key, value) => {
        if (typeof window === 'undefined') return;
        try {
            localStorage.setItem(key, value);
        } catch (e) {
            console.error("localStorage error:", e);
        }
    };

    // Improved fetch function with loading state
    const fetch = async function (tag = null) {
        if (isLoading) return; // Prevent multiple simultaneous fetches
        
        setIsLoading(true);
        setFetchError(null);

        try {
            console.log('Fetching articles with category:', slug, 'filter:', filter, 'offset:', offset);
            
            let data = [];
            // Get filter from state first, fallback to localStorage only if needed
            var type = filter !== '' ? filter : getLocalStorageItem('filterId');
            
            // Parse type to integer if it's a string number
            if (type && !isNaN(parseInt(type))) {
                type = parseInt(type);
            }

            if (type) {
                data = await request.content.articles({ 
                    section: "wellness-center", 
                    tags: tag,
                    category: slug, 
                    type: type, 
                    except_types: [13], 
                    search: search, 
                    sort: sort, 
                    limit: limit, 
                    offset: offset, 
                    user_id: userId, 
                    contact_id: contactId 
                });
            } else {
                data = await request.content.articles({ 
                    section: "wellness-center", 
                    tags: tag,
                    category: slug, 
                    except_types: [13], 
                    search: search, 
                    sort: sort, 
                    limit: limit, 
                    offset: offset, 
                    user_id: userId, 
                    contact_id: contactId 
                });
            }

            console.log('Fetch response:', { 
                dataLength: data?.length || 0, 
                offset, 
                hasMore: more 
            });

            if (!data || !data.length) {
                hasMore(false);
                // If we're at offset 0 and no data, set empty articles array
                if (offset === 0) {
                    setArticles([]);
                }
                setIsLoading(false);
                setFetchInitiated(true);
                return;
            }

            // Update articles with new data
            if (offset === 0) {
                setArticles(data);
            } else {
                setArticles(prevArticles => [...prevArticles, ...data]);
            }

            // Increment offset for next fetch
            setOffset(offset + limit);
            
            // Check if we should show more based on received data length
            if (data.length < limit) {
                hasMore(false);
            }
            
            setFetchInitiated(true);
        } catch (error) {
            console.error("Error fetching articles:", error);
            setFetchError(error.message || "Failed to fetch articles");
            hasMore(false);
            if (offset === 0) {
                setArticles([]);
            }
        } finally {
            setIsLoading(false);
        }
    }

    // Improved reset function that clears all relevant state
    const reset = function () {
        console.log('Resetting state with new filter or slug:', { filter, slug });
        hasMore(true);
        setArticles([]);
        setOffset(0);
        setIsLoading(false);
        setFetchInitiated(false);
        setFetchError(null);
    }
    
    // Handle tab changes and filter/sort changes
    useEffect(() => {
        reset();
    }, [filter, sort]);
    
    // Handle slug changes
    useEffect(() => {
        if (prevSlugRef.current !== slug) {
            console.log('URL slug changed from', prevSlugRef.current, 'to', slug);
            prevSlugRef.current = slug;
            reset();
        }
    }, [slug]);

    // Handle initial load and pagination
    useEffect(() => {
        if (offset === 0 && !fetchInitiated) {
            fetch(tag);
        }
    }, [offset, fetchInitiated, tag]);

    // Initialize filter from localStorage on component mount
    useEffect(() => {
        const filterValue = getLocalStorageItem('filterId');
        // Only set filter state if it's different from current state to avoid re-render loops
        if (filterValue && filterValue !== filter) {
            setFilter(filterValue !== '' ? parseInt(filterValue) : '');
        }
    }, []);

    const classes = "text-reset border-0 rounded-0 bg-transparent px-4 py-3"

    const [isSticky, setSticky] = useState(false);
    const ref = useRef(null);
    const handleScroll = () => {
      if (ref.current) {
        setSticky(ref.current.getBoundingClientRect().top <= 0);
      }
    };

    // Improved button handler
    const toggleButton = (id) => {
        // Reset state before changing filter
        reset();
        
        if (id) {
            setFilter(id);
            setLocalStorageItem('filterId', id.toString());
        } else {
            setFilter('');
            setLocalStorageItem('filterId', '');
        }
    };

    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
  
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);
    
    return(
        <WellnessLayout global={props}>
            <div className="videolibrary wellnessCenter mb-5">
               {hasCat ? (
                    <HeroWrapper 
                        title={cat[0].name}
                        description={cat[0].text || ""}
                        classname={cat[0].bg ? cat[0].bg : herostyles.fileCabinet}
                    />
                ) : category && category.name ? (
                    <HeroWrapper 
                        title={category.name}
                        description=""
                        classname={herostyles.fileCabinet}
                    />
                ) : (
                    <HeroWrapper 
                        title="Category"
                        description=""
                        classname={herostyles.fileCabinet}
                    />
                )}
                
                <div className={`sticky-wrapper text-center bg-white position-sticky top-0 zindex-1 ${isSticky ? ' sticky' : ''}`} ref={ref}>
                    <div className="d-md-block d-none">
						<Button active={!filter} onClick={() => toggleButton(null)} className={classes}>All</Button>
						{sections.map((data,idx) =>
							<Button key={idx} active={filter === data.id} onClick={() => toggleButton(data.id)} className={classes}>
								{data.short_name}
							</Button>
						)}                  
					</div>
                    <div className="d-md-none d-block">						
						<Dropdown className="py-md-3 py-2">
							<Dropdown.Toggle variant="secondary" id="dropdown-basic"><FaBars/> Sections</Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item onClick={() => toggleButton(null)}>All</Dropdown.Item>
								{sections.map((data,idx) =>
									<Dropdown.Item key={idx} onClick={() => toggleButton(data.id)}>{data.short_name}</Dropdown.Item>
								)}    
							</Dropdown.Menu>
						</Dropdown>
					</div>
                    <hr className="mt-0"/>
                </div>
                <div className="wellnessCenter cardscategory m-auto">
                    <div className="d-flex align-items-center">
                        <DropdownButton id="dropdown-basic-button" title={<><FaSortAmountDown/> Sort: { params.sort[sort] } <FaChevronDown className="h7 ml-3" size={9}/></>} className="sortdropdown my-5">
                            <Dropdown.Item onClick={() => setSort("TITLE_ASC")}>{ params.sort.TITLE_ASC }</Dropdown.Item>
                            <Dropdown.Item onClick={() => setSort("DATE_DESC")}>{ params.sort.DATE_DESC }</Dropdown.Item>
                        </DropdownButton>
                    </div>
                    
                    {/* Show loading indicator outside infinite scroll on initial load */}
                    {isLoading && articles.length === 0 ? (
                        <h4 className="text-center">Loading...</h4>
                    ) : fetchError ? (
                        <div className="text-center text-danger">
                            <h4>Error loading content</h4>
                            <p>{fetchError}</p>
                            <Button variant="outline-primary" onClick={() => { reset(); fetch(tag); }}>
                                Retry
                            </Button>
                        </div>
                    ) : (
                        <InfiniteScroll className="px-3" style={{overflow: "hidden"}}
                            dataLength={articles.length} 
                            next={fetch} 
                            loader={<h4 className="text-center">Loading...</h4>}
                            hasMore={more}
                            endMessage={
                                articles.length === 0 
                                    ? <h4 className="text-center">No Content</h4> 
                                    : null
                            }
                            >
                            <Row>
                                {articles.map((data,idx) =>
                                <Col md={3} sm={6} className="mb-4" key={idx} >
                                    <Link href={"/a/" + data.slug} >
                                        <a className="h7 text-reset text-decoration-none">    
                                            <Image variant="top" src={data.theThumbnail ? data.theThumbnail : params.noimage} width={310} height={160}/>
                                            <div className="mt-1 mb-3 pbar">
                                                {
                                                    data.is_read == 1 ? <p className=" mb-0 read h8 text-right position-relative"><FaCheck className="cardCheck"/> You read this</p> : ''
                                                }

                                                {
                                                    data.is_downloaded == 1 ? <p className="read h8 text-right position-relative"><FaCheck className="cardCheck"/> Downloaded</p> : ''
                                                }

                                                {
                                                    data.is_watched == 1 ? <ProgressBar now={40}/> : ''
                                                }
                                            </div>
                                            <p>{data.title}</p>   
                                        </a>
                                    </Link>
                                </Col>
                                )}
                            </Row>
                        </InfiniteScroll>
                    )}
                </div>
            </div>
            <style jsx global>
                {`
                    button.active{
                        border-bottom:2px solid #43a649!important;
                    }
                    #dropdown-more-button{
                        padding: 0 1.5rem!important;
                        position:relative;
                    }
                    .dp-more .dropdown-menu{
                        grid-template-columns: repeat(2, 1fr);
                        top: 13px!important;
                    }
                    .sticky-wrapper button{
                        border-bottom:3px solid transparent!important;
                    }
                    .sticky-wrapper button.active{
                        border-color:#43a649!important;
                    } 
                    .sticky {
                        box-shadow: 0 5px 5px -5px #333;
                    }
                    .sticky button.active{
                        background-color: #43a649!important;
                        color: white!important;
                        padding: .25rem 1rem!important;
                        border-radius: .25rem!important;
                    }

                    .cardscategory{
                        max-width:1334px;
                    }

                    @media (max-width: 991px) {
                        .infinite-scroll-component__outerdiv{
                            text-align: center;
                        }
                        .wellnessCenter .pbar .read{
                            text-align:center!important;
                        }
                    }
                    @media (max-width: 767px) {
                        .sticky-wrapper.position-sticky{
                        	top: 48px !important;
                        }
                    }

                `}
            </style>
        </WellnessLayout>
    )
};

export default CategoryWrapper